const criticalitys = (state = [], action) => {
    switch (action.type) {
      case 'CRITICALITY':
      return {
          type: "CRITICALITY",
          criticalitys: action.criticalitys
        }
      default:
        return state
    }
  }
  
  export default criticalitys